export class ChartExportEventModel {
    chartId: string;
    eventKey: string;
}
